/* import __COLOCATED_TEMPLATE__ from './adi-component.hbs'; */
import Component from '@ember/component';
import { computed } from '@ember/object';
import Utils from '../utils/utils';

export default class AdiComponent extends Component {
    tagName = '';
    defaultName = 'blank-template';

    updateAppData = () => {};
    openHelp = () => {};

    @computed('name') get internalName() {
        let container = Utils.getAppContainer(),
            componentExists = false;

        if (container && container.registry) {
            componentExists = container.registry.has(`component:${this.name}`);
        }

        return componentExists ? this.name : this.defaultName;
    }
}
